import React, { useEffect, useRef, useState } from 'react';
import { clearFiltersIcon } from 'assets';
// import './AutoGroupHeader/AutoGroupHeader.css';

/* eslint-disable react/function-component-definition */
/* eslint-disable arrow-body-style */
export const ClearFilterTemplate = (params) => {
  const {
    api,
    column,
    displayName,
    enableFilterButton,
    enableMenu,
    enableSorting,
    showColumnMenu,
    showFilter,
    setSort,
  } = params;
  const [ascSort, setAscSort] = useState('');
  const [descSort, setDescSort] = useState('ag-hidden');
  const [noSort, setNoSort] = useState('ag-hidden');
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [showClearFilters, setShowClearFilters] = useState(false);
  const menuButtonRef = useRef(null);
  const filterButtonRef = useRef(null);

  const onMenuClicked = (e) => {
    if (!enableMenu) return undefined;

    e.stopPropagation();
    showColumnMenu(menuButtonRef.current);
  };

  const renderMenuButton = () => {
    // early return if enableMenu is disabled in grid options
    if (!enableMenu) return null;

    return (
      <span
        ref={menuButtonRef}
        onClick={onMenuClicked}
        onTouchEnd={onMenuClicked}
        data-ref="eMenu"
        className="ag-header-icon ag-header-cell-menu-button ag-header-menu-icon ag-header-menu-always-show"
        aria-hidden="true"
        style={{ marginRight: showClearFilters ? '14px' : 0 }}
      >
        <span className="ag-icon ag-icon-menu-alt" />
      </span>
    );
  };

  const onFilterClicked = (e) => {
    if (!enableFilterButton) return undefined;

    e.stopPropagation();
    showFilter(filterButtonRef.current);
  };

  const onFilterChanged = () => {
    const activeFilter = column.isFilterActive();
    setIsFilterActive(activeFilter);
    setShowClearFilters(Object.keys(api.getFilterModel()).length > 0);
  };

  const renderFilterButton = () => {
    if (!enableFilterButton) return null;

    return (
      <span
        ref={filterButtonRef}
        onClick={onFilterClicked}
        onTouchEnd={onFilterClicked}
        data-ref="eFilterButton"
        className={`
          ag-header-icon
          ag-header-cell-filter-button
          ${isFilterActive ? 'ag-filter-active' : ''}
        `}
        aria-hidden="true">
          <span className="ag-icon ag-icon-filter" />
      </span>
    )
  };

  const onSortChanged = () => {
    const sort = column.getSort();
    setAscSort(sort === 'asc' ? '' : 'ag-hidden');
    setDescSort(sort === 'desc' ? '' : 'ag-hidden');
    setNoSort(!sort ? '' : 'ag-hidden');
  };

  const onSortRequested = (event) => {
    if (!enableSorting) return undefined;

    const currentSort = column.getSort();

    switch (currentSort) {
      case 'asc':
        setSort('desc', event.shiftKey);
        break;
      case 'desc':
        setSort('', event.shiftKey);
        break;
      default:
        setSort('asc', event.shiftKey);
        break;
    }
  };

  const renderSortIconContainer = () => {
    // early return if enableSorting is disabled in grid options
    if (!enableSorting) return null;

    return (
      <span className="ag-sort-indicator-container">
        <span data-ref="eSortOrder" className="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true" />
        <span data-ref="eSortAsc" className={`ag-sort-indicator-icon ag-sort-ascending-icon ${ascSort}`} aria-hidden="true">
          <span className="ag-icon ag-icon-asc" />
        </span>
        <span data-ref="eSortDesc" className={`ag-sort-indicator-icon ag-sort-descending-icon ${descSort}`} aria-hidden="true">
          <span className="ag-icon ag-icon-desc" />
        </span>
        <span data-ref="eSortMixed" className="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true" />
        <span data-ref="eSortNone" className={`ag-sort-indicator-icon ag-sort-none-icon ag-hidden ${noSort}`} aria-hidden="true">
          <span className="ag-icon ag-icon-none" />
        </span>
      </span>
    );
  };

  useEffect(() => {
    if (!api || !column) return; // Check if API is destroyed before removing listeners
    /**
    * If a column overflows beyond the parent container in the Data Grid, it will be removed from rendering.
    * This unmounting causes the template to lose track of its previous state. As a result, when the column
    * with the clearFilter template is scrolled back into view, both the sort and filter states will be lost,
    * reverting to their default values, even if the grid is currently sorted or filtered.
    * We call these functions on mount to verify if the table is sorted or filtered.
    */
    onSortChanged();
    onFilterChanged();

    // event listener to track changes in column sorting
    column.addEventListener('sortChanged', onSortChanged);

    // event listener to track filter changes
    api.addEventListener('filterChanged', onFilterChanged);
    
    // cleanup event listeners to avoid memory leaks
    return () => {
      if (!api || api.isDestroyed?.()) return; // Check if API is destroyed before removing listeners
      column.removeEventListener('sortChanged', onSortChanged);
      api.removeEventListener('filterChanged', onFilterChanged);
    };
  }, []);

  /*
   * Note: Elements need to be positioned in reverse as Ag-Grid styling applies row-reverse
   * on ag-cell-label-container.
  */
  return (
    <div
      className="ag-cell-label-container ag-header-cell-sorted-asc op2mise-auto-group-header"
      role="presentation"
    >
      {showClearFilters && (
        <div
          className="ag-grid-header-clear-filters"
          style={{ marginTop: '-5px', cursor: 'pointer' }}
          onClick={() => api.setFilterModel(null)}
        >
          <img onMouseEnter={(e) => e.stopPropagation()} src={clearFiltersIcon} alt="clear-filters" title="Clear all filters" />
        </div>
      )}
      {renderMenuButton()}
      {renderFilterButton()}
      <div
        data-ref="eLabel"
        className="ag-header-cell-label"
        role="presentation"
        onClick={(event) => onSortRequested(event)}
      >
        <span data-ref="eText" className="ag-header-cell-text">{displayName}</span>
        {renderSortIconContainer()}
      </div>
    </div>
  );
};